import React from "react";
import { Outlet } from "react-router-dom";

function Student() {
  return <Outlet />;
}

export default Student;
